/**
 * Naming convention for DataSource Link ingest tables.
 *
 * A DataSource Link's `foreignTableName` defaults to `<sanitized datasource
 * title>_<sanitized schema name>`. This is used by the "Manage Data Sources" UI
 * to pre-populate the table-name field when adding or editing a link; the user
 * can override it. The backend stores `foreignTableName` as an opaque value and
 * never regenerates it from the title + schema.
 */

/**
 * Normalize a free-text name into a table-name part: lowercase, every non
 * `a–z0–9` character collapsed to a single underscore, and surrounding
 * underscores trimmed. Digits are preserved. Empty input falls back to
 * `"untitled"`.
 */
export function sanitizeNamePart(s: string): string {
  const sanitized = s
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_+|_+$/g, "");
  return sanitized || "untitled";
}

/**
 * The ingest `foreignTableName` for a DataSource Link binding `dataSourceTitle`
 * to `schemaName` — `<sanitized title>_<sanitized schema name>`.
 */
export function generateLinkTableName(
  dataSourceTitle: string,
  schemaName: string,
): string {
  return `${sanitizeNamePart(dataSourceTitle)}_${sanitizeNamePart(schemaName)}`;
}
